import { App } from 'vue';

import DateSigned from '../components/portal/document/DateSigned.vue3.vue';
import DateTimeSigned from '../components/portal/document/DateTimeSigned.vue3.vue';
import PatientComments from '../components/portal/document/PatientComments.vue3.vue';
import PatientName from '../components/portal/document/PatientName.vue3.vue';
import PatientRelationship from '../components/portal/document/PatientRelationship.vue3.vue';
import PatientSignature from '../components/portal/document/PatientSignature.vue3.vue';
import RelatedPersonName from '../components/portal/document/RelatedPersonName.vue3.vue';

export default function (app: App) {
    // Register injected document components
    app.component('DateSigned', DateSigned);
    app.component('DateTimeSigned', DateTimeSigned);
    app.component('PatientComments', PatientComments);
    app.component('PatientName', PatientName);
    app.component('PatientRelationship', PatientRelationship);
    app.component('PatientSignature', PatientSignature);
    app.component('RelatedPersonName', RelatedPersonName);
}

